<template>
  <div class="login">
    <div>
      <el-row style="margin-top: 150px;">
        <el-input 
          v-model="phoneNum"
          placeholder="请输入手机号码"
        />
      </el-row>
      <el-row :gutter="10" style="margin-right: 40px;margin-top: 20px;">
        <el-col :span="19">
          <el-input
            placeholder="请输入验证码" 
            v-model="code" 
          />
        </el-col>
        <el-col :span="5">
          <el-button v-if="timeBtn" @click="getCode()" style="background-color: #f5f5f5;border: 1px solid #f5f5f5" round size="small">获取验证码</el-button>
          <el-button disabled v-if="!timeBtn" style="background-color: #f5f5f5;border: 1px solid #f5f5f5" round size="small">{{oneMinute}}</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-input 
          v-model="password"
          type="password"
          placeholder="请输入密码（6-20位字母数字的组合）"
        />
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-input 
          v-model="secondePwd"
          type="password"
          placeholder="请重复输入确认密码"
        />
      </el-row>
    </div>
    <el-row style="margin-top: 60px;">
      <el-button @click="goToLog" class="log_btn" style="color: #fff;background-color: #d6918c;border: 1px solid #d6918c" round>提&nbsp;交</el-button>
    </el-row>
    <el-dialog :visible.sync="codeDialog" width="70%" title="图形验证码" :show-close="false">
      <el-row>
        <el-col :span="19">
          <img style="width: 80%;height: 60px;" :src="codeImg" alt="">
        </el-col>
        <el-col :span="5">
          <el-button @click="refresh" type="text" style="font-size: 20px;margin-top: 10px;color: #989898" icon="el-icon-refresh-right"></el-button>
        </el-col>
      </el-row>
      <el-input 
        style="margin-top: 15px;"
        v-model="imgCode"
        placeholder="请输入验证码"
        :disabled="false"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="codeDialog = false">取 消</el-button>
        <el-button size="small" type="danger" @click="dialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { API_1, Global } from "../conf/api";
import { hexMD5 } from '../tools/md5';
import "../assets/css.css";
export default {
  name: "login",
  components: {},
  data() {
    return {
      token: "",
      userid: "",
      userimg: "",
      username: "",
      password: "",
      secondePwd: "",
      phoneNum: "",
      code: "",
      oneMinute: "",
      timeBtn: true,
      codeDialog: false,
      codeImg: "",
      codeKey: "",
      imgCode: "",
      wait: 60
    };
  },
  mounted() {},

  methods: {
    timeMin() {
      if(this.wait == 0) {
        this.timeBtn = true;
        this.wait = 60;
      } else {
        this.oneMinute = `${this.wait}秒后重试`
        this.wait--;
        setTimeout(() => {
          this.timeMin()
        },1000)
      }
    },
    checkPwd(value) {
      var reg = /^\d*$/;
      var reg1 = /^[a-z]*$/i;
      if(!reg.test(value) && !reg1.test(value) && value.length > 6 && value.length < 20) {
        return true;
      } else {
        return false;
      }
    },
    goToLog() {
      if(this.phoneNum == "" || this.code == "" || this.password == "" || this.secondePwd == "") {
        return false;
      } else if(!this.checkPwd(this.password)) {
        this.$toast.text('密码不符合')
        return false;
      }
      let params = {
        code: this.code,
        msgkey: this.msgkey,
        newpassword: hexMD5(this.password),
        receiver: this.phoneNum
      };
      this.axios
        // .post("https://testapi.ccmapp.cn/apis/core/resetpassword", params)
        .post("https://api.ccmapp.cn/apis/core/resetpassword", params)
        .then((res) => {
          if(res.data.code != "200") {
            this.$toast.text(res.data.msg);
          } else {
            this.$toast.text(res.data.msg);
            this.$router.push({
              path: "/login",
              query: {
                platform: this.$route.query.platform
              }
            });
          }
      });
    },
    nonEssentialValidPhone(value) { // 校验手机号
      const reg = /^1[3|4|5|7|8|9]\d{9}$/i;
      if (value == "" ||(value && !reg.test(value)) ) {
        return false
      } else {
        return true
      }
    },
    refresh() {
      this.axios
        // .post("https://testgateway.ccmapp.cn/msg/getVerifyImage",{ token: "5ed618766ba0b526d4f14291" })
        .post("https://gateway.ccmapp.cn/msg/getVerifyImage",{ token: "5ed618766ba0b526d4f14291" })
        .then((res) => {
          this.codeImg = "data:image/jpeg;base64," + res.data.data.imageBase64;
          this.codeKey = res.data.data.imageCodeAesKey;
      });
    },
    getCode() {
      if(this.nonEssentialValidPhone(this.phoneNum)) {
        this.axios
          // .post("https://testgateway.ccmapp.cn/msg/getVerifyImage",{ token: "5ed618766ba0b526d4f14291" })
          .post("https://gateway.ccmapp.cn/msg/getVerifyImage",{ token: "5ed618766ba0b526d4f14291" })
          .then((res) => {
            this.codeImg = "data:image/jpeg;base64," + res.data.data.imageBase64;
            this.codeKey = res.data.data.imageCodeAesKey;
            this.codeDialog = true;
        });
      } else {
        this.$toast.text("请输入有效手机号码");
        return false;
      }
    },
    dialogConfirm() {
      if(this.imgCode == ''){
        this.$toast.text('请输入验证码')
        return false;
      }
      this.axios
        // .post("https://testapi.ccmapp.cn/apis/core/sendverifycode",{
          .post("https://api.ccmapp.cn/apis/core/sendverifycode",{
          receiver: this.phoneNum,
          imagecodekey: this.codeKey,
          imagecode: this.imgCode
        })
        .then((res) => {
          console.log(res)
          if(res.data.code != '200') {
            this.$toast.text(res.data.msg);
            this.imgCode = "";
            this.refresh(); 
          } else {
            this.msgkey = res.data.data.msgkey
            this.$toast.text(res.data.msg);
            this.codeDialog = false;
            this.timeBtn = false;
            this.timeMin();
          }
      });
    },
  },
};
</script>

<style>
.login {
  width: 100%;
  padding: 0 40px;
}
.el-input__inner {
  border: none;
  border-bottom: 1px solid #DCDFE6;
}
.log_btn.is-round {
  padding: 12px 120px;
}
.log1_btn.is-round {
  margin-top: 20px;
  margin-left: 0px;
  padding: 12px 80px;;
}
.log2_btn.is-round {
  margin-top: 20px;
  margin-left: 0px;
  padding: 12px 92px;;
}
</style>
